// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"js/manifest": 0,
	"css/templates/archive-press-releases": 0,
	"css/templates/archive-people-and-stories": 0,
	"css/templates/archive-news-and-activities": 0,
	"css/templates/404": 0,
	"css/app": 0,
	"css/wp-dashboard/login": 0,
	"css/wp-dashboard/editor": 0,
	"css/wp-dashboard/colors": 0,
	"css/wp-dashboard/admin": 0,
	"css/blocks/subscribe-form": 0,
	"css/blocks/slider-highlights": 0,
	"css/blocks/show-posts": 0,
	"css/blocks/quick-links": 0,
	"css/blocks/info-cards": 0,
	"css/blocks/hero": 0,
	"css/blocks/contact-form": 0,
	"css/templates/single-press-releases": 0,
	"css/templates/single": 0,
	"css/templates/search": 0,
	"css/templates/profile-page": 0,
	"css/templates/page-my-bookmarks": 0,
	"css/templates/page-auth": 0,
	"css/templates/index": 0,
	"css/templates/home": 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkskeleton_theme"] = self["webpackChunkskeleton_theme"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));